const theme = {
    "fontFamily": "Roboto",
    "primary": "#5a55ca",
    "secondary": "#001d65",
    "lightBlue": "#3f5173",
    "danger": "#dc3545",
    "grey": "#acb2c0",
    "bodyBg": "#f0f4fd",
    "bodyColor": "#434343",
    "themeGradient": "linear-gradient(180deg, rgba(90, 85, 202, 0.6) 0%, rgba(90, 85, 202, 0.9) 22.58%, #5a55ca 100%)",
}

export default theme